import { useQuery } from "@tanstack/react-query";
import {
  sanityClient,
  newsListQuery,
  newsCountQuery,
  newsArticleQuery,
  type NewsListItem,
  type NewsArticle,
} from "../sanity";

const PAGE_SIZE = 12;

export function useNewsList(page: number) {
  const start = (page - 1) * PAGE_SIZE;
  const end = start + PAGE_SIZE;

  return useQuery({
    queryKey: ["news", "list", page],
    queryFn: () =>
      sanityClient.fetch<NewsListItem[]>(newsListQuery, { start, end }),
    placeholderData: (prev) => prev,
    staleTime: 1000 * 60 * 5,
  });
}

export function useNewsCount() {
  return useQuery({
    queryKey: ["news", "count"],
    queryFn: () => sanityClient.fetch<number>(newsCountQuery),
    staleTime: 1000 * 60 * 5,
  });
}

export function useNewsArticle(slug: string | undefined) {
  return useQuery({
    queryKey: ["news", "article", slug],
    queryFn: () =>
      sanityClient.fetch<NewsArticle | null>(newsArticleQuery, {
        slug: slug ?? "",
      }),
    enabled: !!slug,
    staleTime: 1000 * 60 * 5,
  });
}

export { PAGE_SIZE };
